<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card :title="`${analysisHelpers.getPreferredName(analysis)} Categories (${analysis.categories.length})`">

      <vs-list>
        <template v-for="(category, index) in analysis.categories">
          <vs-list-item :key="index" :title="`${categoryHelpers.getPreferredName(category)}`" :subtitle="categoryHelpers.getPreferredDescription(category)">
            <template slot="avatar">
              <vs-button class="mr-4" color="primary" icon="edit" type="gradient" radius @click="goToCategoryDetail(category.id)"></vs-button>
            </template>
          </vs-list-item>
        </template>
      </vs-list>

      <vs-button class="ml-auto" color="primary" type="border" icon="add" @click="showCreateCategoryDialog">Add New Category</vs-button>


      <vs-prompt
        @accept="createCategory"
        :title="`New ${analysisHelpers.getPreferredName(analysis)} Category`"
        :active.sync="showCreateCategoryDialogFlag">
        <div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input
                class="w-full mb-1"
                label-placeholder="Name"
                v-model="newCategoryModel.name"
              />
              <vs-textarea
                class="w-full mb-1"
                label="Description"
                v-model="newCategoryModel.description"
              />
            </div>
          </div>

        </div>
      </vs-prompt>

    </vx-card>
<!--    <div v-html="jp.toHtml(cyclopedias)"></div>-->
</template>

<script>
  import api from '@/http/api';
  import models from '@/models';
  import {cyclopediaAnalysisHelpers, cyclopediaAnalysisCategoryHelpers} from '@/models/helpers'
  import jsonPrinter from '@/misc/jsonHtmlPrinter';

  export default {
    components: {},
    data() {
      return {
        models: models,
        showCreateCategoryDialogFlag: false,
        newCategoryModel: new models.CyclopediaAnalysisCategory(),
        analysisHelpers: cyclopediaAnalysisHelpers,
        categoryHelpers: cyclopediaAnalysisCategoryHelpers,
        jp: jsonPrinter,
      }
    },
    props: {
      analysis: {
        type: models.CyclopediaAnalysis(),
        required: true,
        default: () => {
          return new models.CyclopediaAnalysis()
        }
      },
    },
    methods: {
      async goToCategoryDetail(categoryId) {
        this.$router.push(`/content/books/analyses/categories/detail?id=${categoryId}`).catch(() => {
        });
      },
      async createCategory() {
        if (this.newCategoryModel.name === '' || this.newCategoryModel.description === '') {
          this.showCreateCategoryDialog(this.newCategoryModel);
          this.showNotification(false, 'Both a name and description are required');
          return;
        }
        this.$vs.loading();

        let newCategory = await api.createNewAnalysisCategory(this.newCategoryModel);

        this.$vs.loading.close();

        if (newCategory !== null && newCategory.id > 0) {
          this.goToCategoryDetail(newCategory.id);
        } else {
          this.showNotification(false, 'Error creating book/title');
        }

      },
      showCreateCategoryDialog(category) {
        this.newCategoryModel = new models.CyclopediaAnalysisCategory(category);
        this.newCategoryModel.cyclopedia_analysis_id = this.analysis.id;
        this.showCreateCategoryDialogFlag = true;
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    },
  }

</script>


<style lang="scss">

</style>

